import React from 'react';
import LanguageProvider from './LanguageProvider';
import ThemeProvider from './ThemeProvider';

// Provider + PersistGate + AppBootstrapper moved to app/StoreShell.jsx, which
// is lazy-loaded by AppRoutes so the landing page never pays the ~195 KB cost
// of @reduxjs/toolkit + all feature slices + redux-persist + react-redux up
// front. Only routes/components that actually use Redux mount StoreShell.
const AppProviders = ({ children }) => (
  <ThemeProvider>
    <LanguageProvider>{children}</LanguageProvider>
  </ThemeProvider>
);

export default AppProviders;
